













import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import dayjs from "dayjs";

@Component
export default class DatePicker extends Vue {
  @Prop() readonly loadingDate!: Promise<unknown[]>;
  @Prop() value!: string;
  @Prop() label!: string;
  @Prop() rules!: unknown;
  @Prop() errorMessages!: string | string[];
  lastValue = "";
  display = "";
  loading = false;

  mounted() {
    this.fetchDate();
    if (this.value) {
      this.setDisplay(this.value);
    }
  }
  @Watch("value")
  onValueChange(newValue: string) {
    if (
      newValue != null &&
      newValue != undefined &&
      newValue !== this.lastValue
    ) {
      this.setDisplay(newValue);
    }
  }
  @Watch("loadingDate")
  onDateChange() {
    this.fetchDate();
  }
  onInput(value: string) {
    const val = dayjs(value, "DD/MM/YYYY").format("YYYY-MM-DD");
    if (val !== this.lastValue) {
      this.lastValue = val;
      this.$emit("input", val);
    }
  }
  setDisplay(value: string) {
    if (value) {
      this.display = dayjs(value).format("DD/MM/YYYY");
      this.lastValue = dayjs(value, "DD/MM/YYYY").format("YYYY-MM-DD");
    } else {
      this.display = "";
      this.lastValue = "";
    }
  }
  fetchDate() {
    if (this.loadingDate) {
      this.loading = true;
    } else {
      this.loading = false;
    }
  }
}
